import React from 'react';

type TitleAnchorContentProps = {
  content: React.ReactNode;
  id: string;
};

export function TitleAnchorContent({ content, id }: TitleAnchorContentProps) {
  return (
    <div className="navigation-block" id={id}>
      {content || null}
    </div>
  );
}
